import React from 'react';
import './PolicyPages.css';

const ShippingPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Shipping Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="policy-content">
          <section>
            <h2>Shipping Areas</h2>
            <p>We currently ship to all locations within India. International shipping is not available at this time.</p>
          </section>

          <section>
            <h2>Processing Time</h2>
            <ul>
              <li><strong>Non-prescription eyewear:</strong> 1-2 business days</li>
              <li><strong>Prescription eyewear:</strong> 3-5 business days (includes lens manufacturing)</li>
              <li><strong>Custom orders:</strong> 5-7 business days</li>
              <li>Orders are processed Monday through Saturday (excluding public holidays)</li>
            </ul>
          </section>

          <section>
            <h2>Shipping Time</h2>
            <ul>
              <li><strong>Chennai:</strong> 1-2 business days</li>
              <li><strong>Tamil Nadu:</strong> 2-3 business days</li>
              <li><strong>Metro Cities (Mumbai, Delhi, Bangalore, Kolkata, Hyderabad):</strong> 3-4 business days</li>
              <li><strong>Other Cities:</strong> 4-6 business days</li>
              <li><strong>Remote Areas:</strong> 7-10 business days</li>
            </ul>
          </section>

          <section>
            <h2>Shipping Charges</h2>
            <ul>
              <li><strong>Free Shipping:</strong> On all orders above ₹999</li>
              <li><strong>Standard Shipping:</strong> ₹50 for orders below ₹999</li>
              <li><strong>Express Shipping:</strong> ₹100 (available for select pin codes)</li>
            </ul>
          </section>

          <section>
            <h2>Shipping Partners</h2>
            <p>We partner with trusted courier services including:</p>
            <ul>
              <li>Blue Dart</li>
              <li>DTDC</li>
              <li>Delhivery</li>
              <li>India Post (for remote areas)</li>
            </ul>
          </section>

          <section>
            <h2>Order Tracking</h2>
            <p>Once your order is shipped, you will receive:</p>
            <ul>
              <li>Shipping confirmation email with tracking number</li>
              <li>SMS notification with tracking link</li>
              <li>Real-time tracking updates via our website</li>
            </ul>
          </section>

          <section>
            <h2>Delivery Attempts</h2>
            <p>Our shipping partners will make up to 3 delivery attempts. After 3 failed attempts, the package will be returned to us. Additional shipping charges may apply for re-delivery.</p>
          </section>

          <section>
            <h2>Cash on Delivery (COD)</h2>
            <ul>
              <li>COD available for orders up to ₹10,000</li>
              <li>₹50 COD handling fee applies</li>
              <li>Please keep exact change ready for delivery</li>
              <li>COD not available for prescription eyewear orders</li>
            </ul>
          </section>

          <section>
            <h2>Delivery Instructions</h2>
            <p>You can provide special delivery instructions during checkout (e.g., leave with neighbor, call before delivery, etc.). Please note that we cannot guarantee all instructions will be followed.</p>
          </section>

          <section>
            <h2>Inspection Upon Delivery</h2>
            <p>Please inspect your package upon delivery. If you notice any damage to the outer packaging or product, please:</p>
            <ul>
              <li>Take photos/videos of the damage</li>
              <li>Note the condition on the delivery receipt</li>
              <li>Contact us immediately at kadharvco@gmail.com</li>
              <li>Do not accept visibly damaged packages</li>
            </ul>
          </section>

          <section>
            <h2>Shipping Delays</h2>
            <p>We are not responsible for delays caused by:</p>
            <ul>
              <li>Incorrect or incomplete shipping address</li>
              <li>Natural disasters or weather conditions</li>
              <li>Strikes or labor disputes</li>
              <li>Customs clearance (if applicable)</li>
              <li>Public holidays or weekends</li>
            </ul>
          </section>

          <section>
            <h2>Contact for Shipping Questions</h2>
            <p>Email: kadharvco@gmail.com<br />
            Phone: +91 94436 53501<br />
            Please have your order number ready for faster assistance.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;